import React from 'react';
import Placeholder from './Placeholder';
import PropTypes from 'prop-types';

/**
 * Renders a loading state until a duck is finished loading OR an error message if something went wrong.
 *
 * @param ducks         The duck to wait for, provided by `duckify`
 * @param content       The content to render once the duck is loaded
 * @param placeholder   The placeholder to render while loading
 * @param errorHandler  Method to display an error
 * @constructor
 */
const DuckLoader = ({
  ducks,
  content,
  placeholder = Placeholder.loading,
  errorHandler = defaultErrorHandler
}) => {
  const anyErrors = ducks.some(d => d.error);

  if (anyErrors) {
    const errorMessages = ducks.map(d => d.errorMessage).filter(x=>x);

    return errorHandler(errorMessages);
  }
  else {
    return placeholder({ready: ducks.every(d => d.ready), content});
  }
};

const defaultErrorHandler = (errorMessages) => <div className={'alert alert-danger'}>
  <ul>
    {errorMessages.map(msg => <li>{msg}</li>)}
  </ul>
</div>;

DuckLoader.propTypes = {
  duck: PropTypes.arrayOf(PropTypes.shape({
    ready: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  })),
  content: PropTypes.func,
  placeholder: PropTypes.func,
  errorHandler: PropTypes.func
}

export default DuckLoader;
